export default [
  {
    name: 'Iugu',
    url: 'https://js.iugu.com/v2'
  },
  {
    name: 'Atlassian',
    url: 'https://jsd-widget.atlassian.com/assets/embed.js?vue&type=script&data-jsd-embedded=true&data-key=d07b981f-1a42-4321-ba77-930963442d42&data-base-url=https%3A%2F%2Fjsd-widget.atlassian.com&lang=js&'
  }
]